// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"09ea2f3a","94":"db3482cc","106":"e502cedb","326":"67ffb629","700":"ea907272","726":"56c05ec2","932":"84e1c46c"}[chunkId] + ".chunk.js";
};